<ng-container *transloco="let t">
  <!-- Shipping calculation in progress -->
  <pxw-alert type="neutral" size="sm" display="inline">
    <pxw-icon icon="loading" [spin]="true" />
    {{ t('shippingCostResponse.calculating') }}
  </pxw-alert>
  <pxw-form-validation
    name="shippingCostCalculation"
    style="margin-top: 0.3em"
    [displayErrors]="isFormSubmitted()"
    [ngModel]="false"
    [requiredTrue]="true"
    [messages]="{ required: t('shippingCostResponse.calculatingError') }"
  />
</ng-container>
